import { Flex } from "@mantine/core";
import { useMergedRef } from "@mantine/hooks";
import classes from "./MessageBubble.module.css";
import type { MessageBubbleProps } from "./types";

export function MessageBubble({
    type,
    shouldShowProactive,
    isLastProactiveMessage,
    overflowRef,
    messageIntersectionRef,
    children,
}: MessageBubbleProps) {
    const mergedRef = useMergedRef(overflowRef, messageIntersectionRef);

    let bubbleClass: string;
    let variant = "reactive";

    switch (type) {
        case "Connection":
        case "Error":
        case "Search":
            bubbleClass = classes.reactiveBubble;
            break;
        case "Proactive":
            if (shouldShowProactive) {
                bubbleClass = classes.proactiveBubble;
                variant = "proactive";
            } else {
                bubbleClass = classes.reactiveBubble;
            }
            break;
        case "Default":
            bubbleClass = isLastProactiveMessage ? classes.proactiveBubble : classes.reactiveBubble;
            variant = "proactive";
            break;
        case "GuideRecommendation":
        case "SessionSummary":
            bubbleClass = classes.aiGeneratedBubble;
            break;
        case "Expert":
        case "QuickAction":
        default:
            bubbleClass = classes.expertBubble;
    }

    return (
        <Flex
            className={
                type === "SessionSummary"
                    ? `fs-mask ${classes.bubble} ${bubbleClass}`
                    : `${classes.bubble} ${bubbleClass}`
            }
            data-testid={`message-bubble-${type}`}
            ref={mergedRef}
            direction="column"
            data-variant={variant}
        >
            {children}
        </Flex>
    );
}
